import React, { Component } from 'react';


class privacy extends Component{

   constructor(props){
   	super(props)


   }

   render(){

   	return(
     
          <div>
             <p> hi there, will add the content shortly </p> 
          </div>
   		)
   }


}

export default privacy